import { Route } from '@angular/router';
import { authGuard, developmentGuard, isDevelopmentBuild } from '@dental-ui/auth';
import { LabShellComponent } from '@dental-ui/lab-shell';


export const appRoutes: Route[] = [
  {
    path: '',
    component: LabShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: () => (isDevelopmentBuild() ? 'main' : 'design-projects'),
      },
      {
        path: 'main',
        canActivate: [developmentGuard],
        loadComponent: () => import('@dental-ui/lab-main').then((m) => m.LabMainComponent),
      },
      {
        path: 'workorders',
        canActivate: [developmentGuard],
        loadComponent: () =>
          import('@dental-ui/lab-workorder').then((m) => m.WorkorderListComponent),
      },
      {
        path: 'workorders/:id',
        canActivate: [developmentGuard],
        loadComponent: () =>
          import('@dental-ui/lab-workorder').then((m) => m.LabWorkorderDetailComponent),
      },
      {
        path: 'design-projects',
        loadComponent: () =>
          import('@dental-ui/lab-designproject').then((m) => m.DesignprojectComponent),
      },
      {
        path: 'calendar',
        canActivate: [developmentGuard],
        loadComponent: () =>
          import('@dental-ui/lab-calendar').then((m) => m.LabCalendarComponent),
      },
      {
        path: 'payments',
        canActivate: [developmentGuard],
        loadComponent: () =>
          import('@dental-ui/lab-payments').then((m) => m.PaymentsComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./lab-settings-page.component').then((m) => m.LabSettingsPageComponent),
      },
    ],
  },
  {
    path: 'mobile-upload/patient/:patientId',
    loadComponent: () => import('@dental-ui/mobile-upload').then((m) => m.MobileUploadComponent),
  },
  {
    path: 'mobile-upload/work-order/:workOrderId',
    loadComponent: () => import('@dental-ui/mobile-upload').then((m) => m.MobileUploadComponent),
  },
];
